import { DEBIT_NOTE_BILL_BASE_RETURN_REQUEST, CREATE_DEBIT_NOTE_BILL_BASE_RETURN, GET_DEBIT_NOTE_BILL_BASE_RETURNS, UPDATE_DEBIT_NOTE_BILL_BASE_RETURN, DELETE_DEBIT_NOTE_BILL_BASE_RETURN, DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, GET_DEBIT_NOTE_BILL_BASE_RETURNS_PAGE
  , DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS
 } from '../types';

const initialState = {
  debitNoteBillBaseReturns: [],
  debitNoteBillBaseReturnsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const debitNoteBillBaseReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEBIT_NOTE_BILL_BASE_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DEBIT_NOTE_BILL_BASE_RETURNS: {
      return {
        ...state,
        debitNoteBillBaseReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DEBIT_NOTE_BILL_BASE_RETURNS_PAGE: {
          const { data, total, page, pageSize, search, where } = action.payload || {};
          return {
            ...state,
            debitNoteBillBaseReturnsPage: [...data],
            total,
            page,
            pageSize,
            search: search || '',
            where: where || {},
            loading: false,
            error: null
          }
        }
    case CREATE_DEBIT_NOTE_BILL_BASE_RETURN:
      return {
        ...state,
        debitNoteBillBaseReturns: [action.payload, ...state.debitNoteBillBaseReturns],
        loading: false,
        error: null
      };
    case UPDATE_DEBIT_NOTE_BILL_BASE_RETURN:
      const debitNoteBillBaseReturnsData = state.debitNoteBillBaseReturns.slice(0);
      const uIndex = debitNoteBillBaseReturnsData.findIndex((data) => data.id === action.payload.id);
      debitNoteBillBaseReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        debitNoteBillBaseReturns: [ ...debitNoteBillBaseReturnsData ],
        loading: false,
        error: null
      };
    case DELETE_DEBIT_NOTE_BILL_BASE_RETURN:
      const debitNoteBillBaseReturns = state.debitNoteBillBaseReturns?.slice(0);
      const index = debitNoteBillBaseReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        debitNoteBillBaseReturns.splice(index, 1);
      }
      return {
        ...state,
        debitNoteBillBaseReturns: [...debitNoteBillBaseReturns],
        loading: false,
        error: null
      }
    case DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case DEBIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default debitNoteBillBaseReturnReducer;